import { Quiz409Translations } from './quizExpired.translation.pl';

export const quizFinishedTranslations: Quiz409Translations = {
  title: 'Quiz zakończony!',
  subMessage: 'Udało Ci się ukończyć wszystkie zadania w ramach quizu.',
  buttons: {
    back: 'Start',
  },
};
